module.exports = __webpack_public_path__ + "img/dong3.aedb259c.gif";